export default function PHP_namespace() {
  return (
    <div>
      <h1>PHP_namespace</h1>
    </div>
  );
}
